// Colors
export const black = 'rgb(0, 0, 0)';
export const white = 'rgb(255, 255, 255)';
export const primaryColor = 'rgb(88, 81, 219)';

export const greyLightColor = 'rgb(205, 207, 208)';
export const greyDarkColor = 'rgb(127, 132, 135)';
